import script from "./HttpProxies.vue?vue&type=script&setup=true&lang=ts"
export * from "./HttpProxies.vue?vue&type=script&setup=true&lang=ts"

import "./HttpProxies.vue?vue&type=style&index=0&id=3e7ac6ca&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e7ac6ca"]])

export default __exports__